import script from "./CardEvento.vue?vue&type=script&setup=true&lang=js"
export * from "./CardEvento.vue?vue&type=script&setup=true&lang=js"

import "./CardEvento.vue?vue&type=style&index=0&id=14d9d555&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14d9d555"]])

export default __exports__